import {
    Form,
    Button,
    Select,
    Result
} from "antd";
import { useState} from "react";
import { useForm } from "antd/lib/form/Form";
import {
    signularisApi,
    useCreateMetaDocumentMutation,
    useGetRecipientsListQuery
} from "../../../store/api/signularisApi";
import { useAppDispatch } from "../../../hooks/redux";
import {CREATE_DOCUMENT_ROUTE, MAIN_PAGE_ROUTE} from "../../../routing/consts";
import { Link } from "react-router-dom";
import {DocTemplateType} from "../../../types/types";
import genDocument7 from "../misc/gendoc7";
import TextArea from "antd/lib/input/TextArea";
import style from '../CreateDocument.module.scss';
import { SendOutlined } from "@ant-design/icons";

const { Item } = Form;
const { Option } = Select;

// Генерирует ID
let guid = () => {
    let s4 = () => Math.floor((1 + Math.random()) * 0x100).toString(10).substring(1);
    return s4() + s4() + s4() + s4();
}

// Форматирование даты
function styledDate() {
    const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", 
                    "августа", "сентября", "октября", "ноября", "декабря"]
    const dobj = new Date()
    return `${dobj.getDate()} ${months[dobj.getMonth()]} ${dobj.getFullYear()}`
}

function Template() {
    const dispatch = useAppDispatch()
    const { data: recipients } = useGetRecipientsListQuery()
    const [form] = useForm()

    // Оригинальные ID и список получателей
    const defaulRepicients = ["6374f9fac845f6fe85e4e3fa", '67175e6e1050798773fca7ff']
    const recipientsList = recipients?.filter(item => !defaulRepicients.includes(item.id)) || []

    const [docname, setDocname] = useState("")
    const [createMetaDocument, {
        isLoading: mutationLoading,
        isSuccess: mutationSuccess,
    } ] = useCreateMetaDocumentMutation()

    const onFinish = async (values: any) => {
        const regnum = guid()
        setDocname('Акт технической экспертизы')
        const formData = new FormData()
        formData.append("title", `Акт технической экспертизы №${regnum}`)
        formData.append("brief", "Сгенерировано из шаблона")
        formData.append("recipients", values.recipients.join(",") + ',' + defaulRepicients.join(","))
        formData.append("documentType", 'technicalExaminationReport')
        
        values.regnum = regnum
        values.regdate = styledDate()
        
        const pdfBytes = await genDocument7(values)
        formData.append("file", new Blob([pdfBytes]))
        
        createMetaDocument(formData)
        dispatch(signularisApi.util.invalidateTags(['MetaDocument']))
    }

    if (mutationSuccess) {
        return (
            <Result
                status="success"
                title="Акт создан"
                subTitle={`Акт технической экспертизы успешно сформирован.`}
                extra={[
                    <Link key="back" to={MAIN_PAGE_ROUTE + '/' + CREATE_DOCUMENT_ROUTE}>
                        <Button type="primary">Создать еще</Button>
                    </Link>
                ]}
            />
        )
    }

    return (
        <div className={style.generatorWrapper}>
            <h2 className={style.title}>Акт технической экспертизы</h2>
            
            <Form 
                form={form} 
                onFinish={onFinish} 
                layout="vertical"
                initialValues={{regtext: "Отделом программно-технического обеспечения ИАУ ГГНТУ в лице"}}
            >
                <Item 
                    label="Дополнительные получатели" 
                    name="recipients" 
                    rules={[{ required: true, message: 'Обязательное поле' }]}
                >
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder="Выберите сотрудников..."
                        size="large"
                        filterOption={(input, option) =>
                            (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    >
                         {recipientsList?.map((recipient) => (
                                <Option key={recipient.id} value={recipient.id} label={recipient.fullname}>
                                {recipient.fullname} {!!recipient.position && <>- <span style={{color: 'gray', fontSize: 12}}>{recipient.position}</span></>}
                                </Option>
                            ))}
                    </Select>
                </Item>

                <div className={style.recipientTags}>
                    <span className={style.tag}>Курбанов Зелимхан Магомедович</span>
                    <span className={style.tag}>Саидов Юсуп Умар-Хажиевич</span>
                </div>

                <Item 
                    label="Текст акта" 
                    className='my-input' 
                    name="regtext" 
                    rules={[{ required: true, message: 'Обязательное поле' }]}
                >
                    <TextArea placeholder="Продолжение текста заявки" rows={5}/>
                </Item>

                <Button 
                    type="primary" 
                    htmlType="submit" 
                    loading={mutationLoading}
                    size="large"
                    icon={<SendOutlined style={{ display: 'inline-flex' }} />}
                    style={{ 
                        width: '100%', 
                        marginTop: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    Создать акт
                </Button>
            </Form>
        </div>
    )
}

export default Template;
